import React, { useEffect, useReducer } from "react";
import KendoExcelExporterDirect from "../../../../components/export/KendoExcelExporterDirect";
import CsvExportDirect from "../../../../components/export/CsvExportDirect";
import { constants } from "../constants/RemittanceLookupConstants";

export default function RemittanceLookupDirectExport(props) {
  const {
    email,
    directExportIsProcessing,
    setDirectExportIsProcessing,
    directExportType,
    setIsDirectExportDataLoading,
    onExportSuccess,
  } = props;

  const [directExportState, dispatchDirectExport] = useReducer(
    directExportReducer,
    null
  );

  function directExportReducer(directExportState, action) {
    let thisAction = action.type.toLowerCase();

    if (thisAction === "clear") {
      return null;
    }

    let thisExportData = null;
    if (action.payload && action.payload.length > 0) {
      let exportColumns = [];
      let exportRows = [];
      let headerProps = constants.payerListExport;

      let thisData = action.payload;

      Object.keys(thisData[0]).forEach((key) => {
        exportColumns.push({
          title: headerProps[key].title,
          type: headerProps[key].type,
          accessor: key,
          hidden: false,
        });
      });

      thisData.forEach((item) => {
        exportRows.push(item);
      });

      if (!exportColumns || exportColumns.length === 0) return null;
      if (!exportRows || exportRows.length === 0) return null;

      exportColumns = exportColumns.filter((item) => item.hidden === false);
      thisExportData = {
        columns: exportColumns,
        rows: exportRows,
      };
    }

    return { ExportType: thisAction, ExportData: thisExportData };
  }

  useEffect(() => {
    if (directExportIsProcessing && directExportType && onExportSuccess) {
      setIsDirectExportDataLoading(true);

      // Simulate async data fetching
      const fetchData = async () => {
        try {
          const data = await onExportSuccess();
          if (data && data.length > 0) {
            dispatchDirectExport({ type: directExportType, payload: data });
          } else {
            console.error("Export failed: No data returned from API");
            alert("Export failed: No payer data available");
            setDirectExportIsProcessing(false);
          }
        } catch (error) {
          console.error("Error fetching export data:", error);
          alert("Export failed: " + error.message);
          setDirectExportIsProcessing(false);
        } finally {
          setIsDirectExportDataLoading(false);
        }
      };

      fetchData();
    }
  }, [directExportIsProcessing, directExportType, onExportSuccess, setDirectExportIsProcessing, setIsDirectExportDataLoading]);

  function DirectExportCompletedCallback() {
    dispatchDirectExport({ type: "clear" });
    setDirectExportIsProcessing(false);
  }

  function GetProcessedExportDataColumns(sourceColumns) {
    let columns = [];

    if (!sourceColumns) return columns;

    if (sourceColumns.length > 0) {
      columns = sourceColumns.map((value) => {
        let newObject = {
          field: value.accessor,
          title: value.title,
        };
        return newObject;
      });
    }
    return columns;
  }

  return (
    <React.Fragment>
      {directExportState &&
       directExportState.ExportType === "excel" &&
       directExportState.ExportData && (
        <KendoExcelExporterDirect
          data={directExportState.ExportData.rows}
          columns={GetProcessedExportDataColumns(
            directExportState.ExportData.columns
          )}
          exportCompletedCallback={DirectExportCompletedCallback}
          exportFileNamePrefix={"PayerList"}
        />
      )}

      {directExportState &&
       directExportState.ExportType === "csv" &&
       directExportState.ExportData && (
        <CsvExportDirect
          columns={[]}
          rows={[]}
          custom={directExportState.ExportData}
          exportCompletedCallback={DirectExportCompletedCallback}
          exportFileNamePrefix={"PayerList"}
        />
      )}
    </React.Fragment>
  );
}
